import type { DocumentPickerAsset } from 'expo-document-picker';

import { useSharedDocumentApi } from '@/features/api/hooks/shared-document/useSharedDocumentApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useUploadTemporaryDocumentItem = () => {
  const api = useSharedDocumentApi();

  return useApiMutation({
    mutationFn: (document: DocumentPickerAsset) =>
      api.uploadTemporaryDocumentItem({ file: document.file ?? new Blob() }),
    errorMessageKey: 'mediaUpload.error',
    onError: (e) => {
      console.error(
        '[useUploadTemporaryDocumentItem]: temporary document upload failed',
        e
      );
    }
  });
};
